export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const AUTH_ERROR = "LOGIN_AUTH_ERROR"

export const UPDATE_PREF_REQUEST = 'UPDATE_PREF_REQUEST';
export const UPDATE_PREF_SUCCESS = 'UPDATE_PREF_SUCCESS';
export const UPDATE_PREF_FAILURE = 'UPDATE_PREF_FAILURE';

export const CLEAR_AUTH_ERROR = "CLEAR_AUTH_ERROR"

export const UPDATE_CURRENT_USER = "UPDATE_CURRENT_USER";